import containerItem from "../type/item/container.js";
import basePage from "./basePage.js";
const choice_page = class extends basePage {
    Background = [];//list class containerItem
    HomeButton = [];//list class containerItem
    Foreground = [];//list class containerItem
    Selection = [];//list class containerItem
    Name = "Choix Compositions";
    constructor(args = {}) {
        super(args);
        this.Background = args.background ? args.background : [];
        this.HomeButton = args.homeButton ? args.homeButton : [];
        this.Foreground = args.foreground ? args.foreground : [];
        this.Selection = args.selection ? args.selection : [];
    }
    checkIsComplete(result = { isComplete: true, requiredBeforeSave: false, missingElements: [] }) {
        result = super.checkIsComplete(result);
        if (this.Selection.length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Page: ${this.Name} - Grille de composition`);
        }
        return result;
    }
    static variableOfInstance() {
        return [
            {property: "Background", construct: containerItem, jsType: "Array"},
            ...super.variableOfInstance(),
            {property: "HomeButton", construct: containerItem, jsType: "Array"},
            {property: "Foreground", construct: containerItem, jsType: "Array"},
            { property: "Selection", construct: containerItem, jsType: "Array" },
        ];
    }
    getPropertiesDescription() {
        return [
            ...super.getPropertiesDescription(),
            { iconSVG: "backgroundIcon", name: "Background", text: "Fond", description: "Éléments de fond de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "backIcon", name: "HomeButton", text: "Bouton retour", description: "Bouton pour revenir à la page d'acceuil", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { name: "Foreground", text: "Avant plan", description: "Éléments en avant plan de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            {
                maxElement: 1, name: "Selection", text: "Choix de composition", description: "Choix de composition", objectType: "ContainerItem", jsType: "Array", constructor: containerItem,
                multipleConstructorParameter: [
                    { id: "COMPOSITION_SELECTION", canBeCopied: false, contents: [{ id: "COMPOSITION_SELECTION_GRID", objectType: "GridElement", canBeRemove: false, canAddElement: false, name: "Grille" }] }
                ]
            }
        ]
    }
}
export default choice_page;